import React from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { CardText, CardTitle, Col, Row } from "reactstrap";
import ButtonComponent from "../../../components/ButtonComponent";
import ControlledTextField from "../../../components/ControlledTextField";
import image from "../../../assets/images/Image1.PNG";
import logo from "../../../assets/images/logo.PNG";
import "./index.css";

type FormData = {
  email: string;
  password: string;
};

const SignUp: React.FC = () => {
  const { control, handleSubmit } = useForm<FormData>();

  const signUp = async (email: string, password: string) => {
    
  };

  const googleSignUp = async () => {
  
  };

  const onSubmit = (data: FormData) => {
    signUp(data.email, data.password);
  };

  return (
    <div className="signUpBackground">
      <div className="auth-wrapper auth-cover">
        <Row className="auth-inner m-0">
          <Col
            className="d-none d-lg-flex align-items-center p-5"
            lg="5"
            sm="12"
          >
            <div className="w-100 d-lg-flex align-items-center justify-content-center">
              <img className="img-fluid" src={image} alt="Login Cover" />
            </div>
          </Col>
          <Col
            className="d-flex align-items-center auth-bg px-2 p-lg-5"
            lg="7"
            sm="12"
          >
            <Col className="px-xl-2 mx-auto" sm="8" md="6" lg="12">
              <div className="imageAreaBackgroundColor">
                <img
                  className="mb-2"
                  src={logo}
                  alt="signupimage"
                  style={{ width: "100%" }}
                />
              </div>
              <CardTitle tag="h2" className="fw-bold mb-1">
                Welcome to Curry King Task Manager Application! 👋
              </CardTitle>
              <CardText className="mb-2">
                Please sign-up to your account and start the adventure
              </CardText>
              <Form
                className="auth-login-form mt-2"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="mb-1">
                  <ControlledTextField
                    label={"Email"}
                    inputName={"email"}
                    inputType={"email"}
                    placeholder={"Enter Your Email"}
                    isRequired={true}
                    control={control}
                  />
                </div>
                <div className="mb-1">
                  <ControlledTextField
                    label={"Password"}
                    inputName={"password"}
                    isRequired={true}
                    placeholder={"Enter Password"}
                    inputType={"password"}
                    control={control}
                    rules={{ required: true }}
                  />
                </div>

                <ButtonComponent title={"Sign Up"} type={"submit"} />
                <ButtonComponent
                  title={"Sign Up with Google"}
                  type={"button"}
                  onClick={googleSignUp}
                />
                <div className="d-flex justify-content-between mt-2">
                  <Link to="/sign-in">
                    {/* <small>Sign In ?</small> */}
                    <ButtonComponent title="Sign In" />
                  </Link>
                </div>
              </Form>
            </Col>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SignUp;
